module.exports = __webpack_public_path__ + "img/arrow-expand.4e4f42ea.svg";